/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { PlayerTaskAssignment } from './PlayerTaskAssignment';
import {
    PlayerTaskAssignmentFromJSON,
    PlayerTaskAssignmentFromJSONTyped,
    PlayerTaskAssignmentToJSON,
    instanceOfPlayerTaskAssignment,
} from './PlayerTaskAssignment';

/**
 * 
 * @export
 * @interface ListTasksForPlayerResponseContent
 */
export interface ListTasksForPlayerResponseContent {
    /**
     * Task assignments scoped to the authenticated experience.
     * @type {Array<PlayerTaskAssignment>}
     * @memberof ListTasksForPlayerResponseContent
     */
    tasks: Array<PlayerTaskAssignment>;
}


/**
 * Check if a given object implements the ListTasksForPlayerResponseContent interface.
 */
export function instanceOfListTasksForPlayerResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tasks" in value;
    return isInstance;
}

export function ListTasksForPlayerResponseContentFromJSON(json: any): ListTasksForPlayerResponseContent {
    return ListTasksForPlayerResponseContentFromJSONTyped(json, false);
}

export function ListTasksForPlayerResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTasksForPlayerResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'tasks': ((json['tasks'] as Array<any>).map(PlayerTaskAssignmentFromJSON)),
    };
}

export function ListTasksForPlayerResponseContentToJSON(value?: ListTasksForPlayerResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'tasks': ((value.tasks as Array<any>).map(PlayerTaskAssignmentToJSON)),
    };
}

